import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "plan" }
const _hoisted_2 = { class: "plan__title" }
const _hoisted_3 = { class: "plan__title-text" }
const _hoisted_4 = { class: "plan__title-content" }
const _hoisted_5 = { class: "plan__title-btn btns btns btns--font-large" }
const _hoisted_6 = {
  key: 1,
  class: "subscription-error"
}
const _hoisted_7 = { class: "plan-details-annual" }
const _hoisted_8 = { class: "plan-details-annual__top" }
const _hoisted_9 = { class: "plan-details-annual__top-left" }
const _hoisted_10 = { class: "plan-details-name" }
const _hoisted_11 = { class: "plan-details-annual__top-right" }
const _hoisted_12 = {
  key: 0,
  class: "plan-details-annual__top-right-text plan-details__top-right-text--discount"
}
const _hoisted_13 = {
  key: 1,
  class: "plan-details-annual__top-right-text"
}

import { ref } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { BillingView } from '@/models/billing'
import ChangeBillingPeriodPopup from './ChangeBillingPeriodPopup.vue'

import PlanDate from './BillingDataPaid.PlanDate.vue'
import { PlanChangeFailedError } from '@/services/cordova.purchase.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingDataPaid.PlanInfo.Annual',
  props: {
    billing: {}
  },
  emits: ['subscribed'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const wait = useWait()
const emit = __emit

const popupMonthly = ref<InstanceType<typeof ChangeBillingPeriodPopup> | null>(
  null,
)

const error = ref<string | null>(null)

async function switchMonthly(): Promise<void> {
  if (!props.billing.is_trial) {
    popupMonthly.value?.show()
    return
  }

  error.value = null
  try {
    wait.start('Subscribing')
    await props.billing.subscribeTo(props.billing.monthlyPlan)
    emit('subscribed')
    wait.end('Subscribing')
  } catch (err) {
    if (err instanceof PlanChangeFailedError) {
      error.value = err.message
    }
    wait.end('Subscribing')
  }
}

async function reactivate(): Promise<void> {
  try {
    wait.start('Subscribing')
    await props.billing.subscribeTo(props.billing.plan)
    emit('subscribed')
    wait.end('Subscribing')
  } catch (error) {
    wait.end('Subscribing')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_button_spinner = _resolveComponent("button-spinner")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "plan__title-name" }, "Your Plan", -1)),
        _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.billing.planName), 1)
      ]),
      _createElementVNode("div", null, [
        (__props.billing.allowPlanChange)
          ? (_openBlock(), _createBlock(_component_v_wait, {
              key: 0,
              for: "Subscribing"
            }, {
              waiting: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Processing... ", -1)),
                  _createVNode(_component_button_spinner)
                ])
              ]),
              default: _withCtx(() => [
                (
              __props.billing.cancel_at_period_end || __props.billing.change_plan_at_period_end
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "plan__title-btn btns btns btns--font-large",
                      onClick: reactivate
                    }, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("span", null, " Reactivate ", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "plan__title-btn btns btns--white btns--font-large",
                      onClick: switchMonthly
                    }, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("span", null, " Switch to Monthly ", -1)
                    ]))]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (error.value !== null && error.value !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        _createVNode(ChangeBillingPeriodPopup, {
          ref_key: "popupMonthly",
          ref: popupMonthly,
          billing: __props.billing,
          targetPlan: __props.billing.monthlyPlan,
          title: "Change to Monthly Subscription",
          confirmButtonText: "Change to Monthly"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, " By changing to monthly billing, you'll lose out on " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "% savings. ", 1),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, " You won't be charged until your annual subscription credits are used up. ", -1))
          ]),
          _: 1
        }, 8, ["billing", "targetPlan"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "plan-details-title plan-details-title--annual" }, "Details", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(__props.billing.plan.nickname) + " Plan", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (__props.billing.showPricesAfterDiscount)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" $147.75/yr ", -1),
                _createElementVNode("span", null, " ($0 for 3mo, then $16.42/mo) ", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(__props.billing.currentPeriodPrice.withPeriod.perYear), 1))
        ])
      ])
    ]),
    _createVNode(PlanDate, { billing: __props.billing }, null, 8, ["billing"])
  ]))
}
}

})